export { default } from './SingleSection';
